import type { TNavbarMenuBurgerContentElement } from '@shared/dream-components';
import { NavbarMenuBurgerContentV2 as NavbarMenuBurgerContentElement } from '@shared/dream-components';
import { type ReactNode, Suspense, useContext } from 'react';
import { NavbarBurgerContext } from './NavbarMenuBurger.context';

interface Props {
  node: TNavbarMenuBurgerContentElement;
  children: ReactNode | ReactNode[];
  screen: 'desktop' | 'mobile';
}

const NavbarMenuBurgerContent = ({ node, children, screen }: Props) => {
  const { isOpen } = useContext(NavbarBurgerContext);

  return (
    <Suspense fallback={null}>
      <NavbarMenuBurgerContentElement
        element={node}
        screen={screen}
        attributes={{ 'data-is-open': isOpen }}
        controlbyselected="false"
      >
        {children}
      </NavbarMenuBurgerContentElement>
    </Suspense>
  );
};

export default NavbarMenuBurgerContent;
